import(/* webpackMode: "eager", webpackExports: ["VaultsContainerWithSuspense"] */ "/vercel/path0/packages/app/src/features/vaults/VaultsContainer.tsx");
